// Порядок украинского алфавита: в обычной сортировке по кодам «і» и «ї» оказались бы после «я».
const ALPHABET = " -'абвгґдеєжзиіїйклмнопрстуфхцчшщьюя";

const key = (name) => Array.from(String(name).toLowerCase()).map((c) => (ALPHABET.includes(c) ? ALPHABET.indexOf(c) : 100 + c.charCodeAt(0)));

// Для sort(): названия по украинскому алфавиту.
export const byUkrainianAlphabet = (a, b) => {
  const [x, y] = [key(a), key(b)];
  for (let i = 0; i < Math.min(x.length, y.length); i += 1) {
    if (x[i] !== y[i]) return x[i] - y[i];
  }
  return x.length - y.length;
};
